module.exports = __webpack_public_path__ + "img/empty-state-permits.709f94c8.png";